<template>
  <div class="bg-black height-100 watch-info">
    <div class="main-play">
      <div class="flex play-tit">
        <!-- <a-row type="flex" class="title" justify="space-between" align="middle"> -->
        <div :span="12" class="flex align-center">
          <span class="schedule-name">{{ videoData.scheduleName }}</span>
          <!-- <span class="middle">{{ watchNum && watchNum.watchNum ? watchNum.watchNum : 0 }}人在线</span> -->
        </div>
        <div :span="6" class="flex align-center">
          <div @click="goAsk()" class="flex align-center cursor" style="margin-right: 20px">
            <img src="./img/ask-icon.png" class="icon-play" />提问
          </div>
          <div @click="goEvaluate()" class="flex align-center cursor" v-if="isShowEva" style="margin-right: 20px">
            <img src="./img/evaluate-icon.png" class="icon-play" />评价
          </div>
          <div @click="gpResource()" class="flex align-center cursor">
            <img src="./img/resource-icon.png" class="icon-play" />资源
          </div>
          <div class="header_title">
            <h1 class="icon_container">
              <div class="icon" v-if="userInfo.nickName">
                <img :src="userInfo.headImgUrl" alt="" class="stu-logo" />
              </div>
              <span>{{ userInfo.nickName }}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div id="play">
      <!-- <Loading @loaded="loadFinished()" /> -->
      <div v-if="loaded" id="play-box">
        <div class="main-container">
          <!-- 白板区域 -->
          <div class="left-panel">
            <Barrage ref="barrage" />
            <WhiteBoard />
          </div>
          <!-- 回放目录区域 -->
          <!-- <div class="menus-panel">
          <MenusPanel :pages="pages" />
          </div> -->
          <!-- 右侧交互区域 -->
          <div class="right-panel">
            <!-- 播放器 -->
            <div class="player-panel">
              <Player ref="player" @getDuration="mountSlider = true" :videoInfo="videoInfo" />
              <!-- <div v-if="videoData.scene !== 'video'" class="change-video">
                <a-icon type="retweet" style="font-size: 16px; color: #fff" @click="pptVideoSwitch" />
              </div> -->
            </div>
            <!-- 聊天列表、用户列表、发言列表、公告、问答等 -->
            <div class="interaction-panel" :class="videoData.scene === 'video' ? 'video-top' : ''">
              <!-- <div class="tab-title">
              <span @click="setTab('user')" class="title" :class="{ active: checkActiveTab('user') }">用户列表</span>
              <span @click="setTab('message')" class="title" :class="{ active: checkActiveTab('message') }">聊天</span>
              <span @click="setTab('action')" class="title" :class="{ active: checkActiveTab('action') }">发言列表</span>
            </div> -->
              <div class="tab-body">
                <!-- <Notice /> -->
                <div class="tab-item" v-show="activeTab === 'user'">
                  <!-- <UserList /> -->
                </div>
                <div class="tab-item" v-show="activeTab === 'message'">
                  <MessageList />
                </div>
                <div class="tab-item" v-show="activeTab === 'action'">
                  <!-- <ActiveList /> -->
                </div>
                <!-- <QuestionAnswer /> -->
              </div>
            </div>
          </div>
        </div>

        <!-- 回放控制条 -->
        <div class="footer-panel">
          <span class="volume-control">
            <!-- 音量控制 -->
            <i @click="toggleVolumeSlider()" class="icon icon-volume"></i>
            <div v-show="showVolumeSlider">
              <VolumeSlider />
            </div>
          </span>
          <!-- 播放暂停 -->
          <i @click="togglePlay()" class="icon" :class="isPlaying ? 'icon-play' : 'icon-pause'"></i>
          <!-- 切换视频 -->
          <!-- <a-icon type="retweet" style="font-size: 16px; color: #fff" @click="pptVideoSwitch" /> -->
          <!-- 控制条 -->
          <PlayerSlider v-if="mountSlider" @getVideoTime="getVideoTime" @getChangeVideoTime="getChangeVideoTime" />
          <!-- 弹幕 -->
          <!-- <i @click="toggleBarrage()" class="icon" :class="barrageOn ? 'icon-barrage-on' : 'icon-barrage-off'"></i> -->
          <!-- 倍速 -->
          <PlaybackSpeedControl v-model="currentSpeed" />
          <!-- 清晰度 -->
          <select v-model="currentQuality" name="quality" id="quality-control" title="清晰度">
            <option v-for="(item, index) in qualityList" :key="index" :value="item.type">
              {{ item.name }}
            </option>
          </select>
          <!-- 全屏 -->
          <!-- <i @click="toggleVolumeSlider()" class="icon arrows-alt"></i> -->
          <a-icon type="fullscreen" @click="toggleWhiteboardFull()"
            style="font-size:20px; color: #fff;margin-left:20px; font-weight: bold;" />
        </div>
        <!-- 模态框组件 -->
        <!-- <ModalPanel /> -->
      </div>
    </div>
    <ask-modal :visible.sync="askVisible" @refresh="refresh"></ask-modal>
    <evaluate-modal :visible.sync="evaluateVisible" @refresh="evaluatRefresh"
      :scheduleId="studentData.scheduleId"></evaluate-modal>
    <resource :pushType="videoData.pushType" :classesName="videoData.classesName" v-if="videoData.activityStatus !== 0"
      :visible.sync="resourceVisible" :activityInfo="videoData" :planclassesId="studentData.planclassesId"
      @getResorce="getResorce" :resourceList="resourceList" @analysisPPt="analysisPPt" @closeResource="closeResource">
    </resource>
  </div>
</template>

<script>
import Vue from 'vue'
import Loading from './components/Loading'
import WhiteBoard from './components/WhiteBoard'
import Player from './components/Player'
import UserList from './components/UserList'
import MessageList from './components/MessageList'
import Notice from './components/Notice'
import QuestionAnswer from './components/QuestionAnswer'
import PlayerSlider from './components/PlayerSlider'
import MenusPanel from './components/MenusPanel'
import VolumeSlider from './components/VolumeSlider'
import ModalPanel from './components/ModalPanel'
import ActiveList from './components/ActiveList'
import Barrage from './components/Barrage'
import resource from '@/components/wacthModule/resource'
import askModal from '@/components/wacthModule/askModal'
import evaluateModal from '@/components/evaluateModal/evaluateModal'
import PlaybackSpeedControl from '@/components/PlaybackSpeedControl'

export default {
  name: 'App',
  components: {
    Loading,
    WhiteBoard,
    Player,
    PlayerSlider,
    MenusPanel,
    UserList,
    MessageList,
    Notice,
    QuestionAnswer,
    VolumeSlider,
    ModalPanel,
    ActiveList,
    Barrage,
    resource,
    askModal,
    evaluateModal,
    PlaybackSpeedControl,
  },
  data() {
    return {
      videoData: {},
      userInfo: Vue.ls.get('USER_INFO'),
      loaded: false,
      activeTab: 'message',
      // 视频资源，作为props传给Player组件
      videoInfo: null,
      showVolumeSlider: false,
      isPlaying: false,
      qualityList: [],
      pages: [],
      currentQuality: '',
      currentSpeed: 1,
      mountSlider: false,
      barrageOn: false,
      isShowEva: true,
      watchNum: null,
      studentData: {},
      watchTimer: null,
      scanBeginTime: 0,
      resourceList: [],
      doExerciseVisible: true,
      evaluateVisible: false,
      askVisible: false,
      resourceVisible: false,
      bjyLastWatchTime: 0,
      bjyStartWatchTime: 0,
      isFull: false,
      multiple: 1,
    }
  },
  created() {
    this.initData()
    // this.playInit()
    document.querySelector('body').setAttribute('style', 'overflow: auto')
  },
  destroyed() {
    this.saveWatchTime(1)
    console.log('disconnect............')
    if (this.watchTimer) {
      clearInterval(this.watchTimer)
    }
  },
  mounted() {
    const that = this
    // setTimeout(function () {
    //   if (that.videoData.scene === 'video') {
    //     that.pptVideoSwitch()
    //     $('.bjy-playback-player video').css({ 'height': 'calc(100vh - 100px)' })
    //   }
    // }, 1500)
    BJY.store.watch('isPlaying', (isPlaying) => {
      this.isPlaying = isPlaying
    })
    window.onbeforeunload = function () {
      that.saveWatchTime(1)
    }
  },
  methods: {
    async initData() {
      this.userInfo = Vue.ls.get('USER_INFO')
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
      if (this.watchTimer) {
        clearInterval(this.watchTimer)
      }
      // if (!window.PolyvLiveSdk) {
      //   loadJs(this.playerJsSrc, this.loadPlayer)
      // }
      this.scanBeginTime = parseInt(new Date().getTime())
      await this.getStuVieoCheck()
      await this.getResorce()
    },
    // 获取视频/直播详情数据
    async getStuVieoCheck() {
      const res = await this.$http.get(
        `/b/classes/web/bjy/live/schedule/group/info/${this.studentData.planclassesId}/${this.studentData.classesId}/${this.studentData.scheduleId}`
      )
      this.videoData = res
      this.isShowEva = !res.hasComment
      const rz = await this.$http.get(
        `/b/classes/biz/classes/schedule/getScheduleDefinition`, {
          params: {
            scheduleId: this.studentData.scheduleId,
          },
        }
      )
      this.qualityList = rz || []
      this.currentQuality = rz && rz.length > 0 ? rz[0].type : ''
      // // console.log('this.videoData', this.videoData)
      // const time = res
      // if (time.startTime && time.endTime) {
      //   const start = time.startTime.split(' ')
      //   const end = time.endTime.split(' ')
      //   res.end = start[0] === end[0] ? end[1] : res.endTime
      // }
      const that = this
      this.watchTimer = setInterval(() => {
        // this.saveLastWatchTime()
        that.saveWatchTime()
      }, 60000)
      this.playInit()
    },
    playInit() {
      // var options = {
      //   token: '3zp59V7u0Zng3M3qox2l6Z_9XKV43emRMnqgAQ3mp2X3qOvoWXcZdql8gZ-alGJMCqdH1zJ1Si0',
      //   classId: '21092486271780',
      //   sessionId: 0,
      //   prefixName: 'tiansujing'
      // }
      var options = {
        token: this.videoData.token,
        classId: this.videoData.channelId,
        sessionId: this.videoData.sessionId,
        prefixName: 'tiansujing',
        group: this.videoData.groupId
      }
      // 给一个调试入口，从url的query读取: url里面包含debug=1的话可以使用url进入
      if (location.href.includes('debug=1')) {
        // <!-- 这里给一个测试入口：输入回放的url即可测试对应的回放 -->
        var url = prompt('输入回放url以测试')
        // 有回放链接用回放链接，没有回放链接用我们的测试用例
        try {
          if (url) {
            var params = this.getQuery(url)
            options.token = params.token
            options.classId = params.classid
            options.sessionId = Number(params.session_id) || 0
            options.prefixName = params.prefixName
          }
          // console.log(options)
        } catch (error) {
          alert('您输入的链接不存在或格式有误！')
        }
      }

      BJY.playback
        .init({
          env: 'production',
          privateDomainPrefix: options.prefixName,
          token: options.token,
          class: {
            id: options.classId,
            sessionId: options.sessionId
          },
          useEncrypt: true,
          user: {
            number: this.videoData.number,
            avatar: this.videoData.avatar,
            name: this.videoData.name,
            type: 0,
            group: options.group
          }
        })
        .then((data) => {
          console.log('222', data)
          this.videoInfo = data
          this.videoInfo.scene = this.videoData.scene
          this.videoInfo.lastWatchTime = this.videoData.lastWatchTime
          this.videoInfo.defaultDefinition = this.currentQuality
          this.pages = data.pages
          if (this.qualityList && this.qualityList.length === 0) {
            this.qualityList = data.definition
            this.currentQuality = data.defaultDefinition
          }
        })
      // this.currentQuality = this.currentQuality
      var eventEmitter = BJY.eventEmitter
      eventEmitter.on(eventEmitter.PLAYBACK_SIGNAL_FETCH_END, () => {
        // console.log('start render')
        this.loaded = true
      })
    },
    loadFinished() {
      $('#main').css('opacity', 1)
    },
    checkActiveTab(tab) {
      return this.activeTab === tab
    },
    setTab(tab) {
      this.activeTab = tab
    },
    toggleVolumeSlider() {
      this.showVolumeSlider = !this.showVolumeSlider
    },
    toggleBarrage() {
      this.$refs.barrage.toggleBarrage()
      this.barrageOn = !this.barrageOn
    },
    togglePlay() {
      this.$refs.player.togglePlay()
    },
    getQuery(url) {
      var query = url.split('?')[1]
      // 获取自定义域名
      var prefixName = url.split('.')[0].split('//')[1]

      var list = query.split('&')
      var params = {
        prefixName: prefixName
      }
      list.forEach((item) => {
        var pair = item.split('=')
        params[pair[0]] = pair[1]
      })
      return params
    },
    async saveWatchTime(type) {
      const scanEndTime = parseInt(new Date().getTime())
      const params = {
        activityId: this.videoData.activityId,
        classesId: this.studentData.classesId,
        scheduleId: this.studentData.scheduleId,
        planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
        state: this.videoData.activityStatus
      }
      const time = this.bjyLastWatchTime - this.bjyStartWatchTime
      params.startTimeStamp = this.scanBeginTime
      params.endTimeStamp = scanEndTime
      params.startTime = parseInt(this.bjyStartWatchTime * 1000)
      params.endTime = parseInt(this.bjyLastWatchTime * 1000)
      params.videoPlayedTime = parseInt(time * 1000)
      // if (type) {
      //   params.watchDuration = 0
      // } else {
      //   params.watchDuration = 60000
      // }
      params.watchDuration = parseInt(scanEndTime - this.scanBeginTime)
      this.bjyStartWatchTime = this.bjyLastWatchTime
      if (time === 0 || time < 0) {
        return
      }
      // console.log('params', params)
      await this.$http.post(`/b/classes/live/v2/saveVideoProgressForPc`, params)
      this.scanBeginTime = scanEndTime
    },
    async getResorce() {
      this.resourceList = await this.$http.get('/b/classes/web/stu/schedule/resource/v2/' + this.studentData.scheduleId)
    },
    goAsk() {
      this.askVisible = true
    },
    refresh() {
      // console.log(this.$refs.postRef)
      this.askVisible = false
    },
    goEvaluate() {
      this.evaluateVisible = true
    },
    evaluatRefresh() {
      // console.log(this.$refs.postRef)
      this.evaluateVisible = false
      this.isShowEva = false
    },
    gpResource() {
      this.resourceVisible = true
    },
    closeResource() {
      this.resourceVisible = false
    },
    analysisPPt(urls) {
      this.itemUrls = urls
      if (!this.itemUrls || this.itemUrls.length < 1) {
        this.$message.info('当前讲义没有数据')
      }
    },
    swap(presenterCameraNode, whiteboardNode) {
      var presenterCameraParentNode = presenterCameraNode.parentNode
      var whiteboardParentNode = whiteboardNode.parentNode
      var presenterCameraPlaceholder = document.createElement('div')
      var whiteboardPlaceholder = document.createElement('div')

      presenterCameraParentNode.insertBefore(
        presenterCameraPlaceholder,
        presenterCameraNode
      )
      whiteboardParentNode.insertBefore(whiteboardPlaceholder, whiteboardNode)

      whiteboardNode &&
        presenterCameraParentNode.insertBefore(
          whiteboardNode,
          presenterCameraPlaceholder
        )
      presenterCameraNode &&
        whiteboardParentNode.insertBefore(presenterCameraNode, whiteboardPlaceholder)

      presenterCameraParentNode.removeChild(presenterCameraPlaceholder)
      whiteboardParentNode.removeChild(whiteboardPlaceholder)
    },

    // 切换ppt与主讲视频位置，如需同步切换，可通过自定义信令实现
    pptVideoSwitch() {
      const presenterDom = $('.bjy-playback-player')[0]
      const whiteboardDom = $('.bjy-whiteboard')[0]
      console.log('1111', presenterDom, whiteboardDom)
      // this.changePosition(presenterDom, whiteboardDom)
      this.swap(presenterDom, whiteboardDom)
      // eventEmitter.trigger(eventEmitter.WINDOW_RESIZE)
    },
    getVideoTime(e) {
      // console.log('123', e)
      this.bjyLastWatchTime = e
    },
    getChangeVideoTime(e) {
      this.bjyLastWatchTime = e
      this.saveWatchTime(1)
    },
    toggleWhiteboardFull() {
      var dom = document.getElementById('whiteboard')
      this.fullScreen(dom)
      this.isFull = !this.isFull
    },
    fullScreen(dom) {
      if (dom.requestFullscreen) {
        return dom.requestFullscreen()
      } else if (dom.webkitRequestFullScreen) {
        return dom.webkitRequestFullScreen()
      } else if (dom.mozRequestFullScreen) {
        return dom.mozRequestFullScreen()
      } else {
        return dom.msRequestFullscreen()
      }
    },
    exitFullScreen() {
      var dom = document
      if (dom.exitFullscreen) {
        dom.exitFullscreen()
      } else if (dom.webkitExitFullscreen) {
        return dom.webkitExitFullScreen()
      } else if (dom.mozRequestFullscreen) {
        return dom.mozExitFullscreen()
      } else {
        return dom.msExitFullscreen()
      }
    }
  },
  watch: {
    currentQuality(newValue, oldValue) {
      console.log('清晰度切换为：' + newValue)
      this.videoInfo.defaultDefinition = newValue
      if (this.$refs.player) {
        this.videoInfo.lastWatchTime = this.bjyLastWatchTime
        this.$refs.player.loadVideo(newValue)
        if (BJY.store.get('teacherVideo')) {
          BJY.store.set('teacherVideo.playbackRate', this.multiple || 1)
        }
      }
    },
    currentSpeed(newValue, oldValue) {
      console.log('播放速度切换为：' + newValue)
      this.multiple = Number(newValue)
      if (BJY.store.get('teacherVideo')) {
        BJY.store.set('teacherVideo.playbackRate', Number(newValue) || 1)
      }
    },
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
<style lang="scss">
@import './assets/iconfont/iconfont.css';

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  font-size: 13px;
  line-height: 13px;

  #play {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: calc(100vh - 60px);
    width: 100%;
    position: fixed;

    #play-box {
      height: 100%;

      .main-container {
        height: calc(100% - 40px);
        display: flex;
        flex-direction: row;

        .left-panel {
          flex: 1;
          position: relative;
          background-image: url('./assets/img/class-panel-bg.jpg');
        }

        .right-panel {
          width: 280px;
          // box-shadow: 5px -5px 5px 5px #789;
          position: relative;

          .player-panel {
            // height: 210px;
            width: 100%;
            background: #000;
          }

          .interaction-panel {
            position: absolute;
            top: 160px;
            width: 100%;
            bottom: 0;

            .tab-title {
              height: 32px;
              line-height: 32px;
              width: 100%;
              display: flex;
              justify-content: space-around;

              .title {
                cursor: pointer;
                width: 33.33%;
                font-size: 13px;
                text-align: center;
                line-height: 30px;
              }

              .active {
                border-bottom: 2px solid #55a3ff;
              }
            }

            .tab-body {
              position: absolute;
              top: 6px;
              width: 100%;
              // bottom: 36px;
              bottom: 5px;
              box-sizing: border-box;

              .tab-item {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      .footer-panel {
        height: 40px;
        padding: 0 20px;
        // position: absolute;
        // bottom: 0;
        // left: 0;
        // right: 0;
        background: #313339;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icon {
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          cursor: pointer;
          margin: 0 6px;
          height: 15px;
        }

        .volume-control {
          display: inline-block;
          position: relative;

          .icon-volume {
            font-size: 20px;
          }

          .bjy-volume-slider {
            position: absolute;
            bottom: 100%;
          }
        }

      }
    }
  }
}
</style>
